import FlowchartEditor from '../components/Flowchart/FlowchartEditor';

export default function FlowchartEditPage() {
  return <FlowchartEditor />;
}
